export default "__VITE_ASSET__B9tfR887__"